import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import Drip from 'drip';
var dayStr = ['日', '一', '二', '三', '四', '五', '六'];
var SHOW_STATUS = {
  DELAY: 1,
  // 延期
  CANCEL: 2,
  // 取消
  TO_SALE: 3,
  // 即将开售
  STOCK_OUT: 4,
  // 缺货登记
  SOLD_OUT: 5,
  // 售罄
  NORMAL: 6,
  // 正常
  PRE: 7 // 可预约
};

export default {
  name: 'ShowsCard',
  props: {
    dateCardList: {
      type: Array
    },
    performanceId: {
      type: Number
    },
    modelStyle: {
      type: Number
    },
    hasMore: {
      type: Boolean
    },
    isDegradeCalPrice: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      cardList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.loadFontFace();
    var flag = false;
    try {
      if (this.hasMore) {
        window.seedAction({
          evt: 'view',
          bid: 'b_movie_rk4d19v6_mv',
          cid: 'c_c21utqjf',
          custom: {
            performance_id: this.performanceId
          }
        });
      }
      window.seedAction({
        evt: 'view',
        bid: 'b_movie_tztra8n3_mv',
        cid: 'c_c21utqjf',
        custom: {
          performance_id: this.performanceId
        }
      });
      this.cardList = this.dateCardList.slice(0, 7).map(function (item, index) {
        var isToday = dayjs(item.day).isToday();
        var showTimeList = item.performances;
        var statusText = '',
          customClass = '',
          price = '';
        var customId = '';
        if (item.dateStatusTag === SHOW_STATUS.NORMAL) {
          if (!flag) {
            flag = true;
            customId = 'view-card';
          }
          price = item.minSellPrice;
        }
        if (item.dateStatusTag === SHOW_STATUS.SOLD_OUT) {
          // 售罄
          statusText = '售罄';
          customClass = 'disabled';
        }
        if (item.dateStatusTag === SHOW_STATUS.STOCK_OUT) {
          // 缺货登记
          statusText = '缺货登记';
          customClass = 'outOfStock';
        }
        if (item.dateStatusTag === SHOW_STATUS.TO_SALE) {
          if (!flag) {
            flag = true;
            customId = 'view-card';
          }
          // 即将开售
          statusText = '即将开售';
          customClass = 'willSale';
        }
        if (item.dateStatusTag === SHOW_STATUS.DELAY) {
          // 延期
          statusText = '延期';
          customClass = 'disabled';
        }
        if (item.dateStatusTag === SHOW_STATUS.CANCEL) {
          // 取消
          statusText = '取消';
          customClass = 'disabled';
        }
        if (item.dateStatusTag === SHOW_STATUS.PRE) {
          // 可预约
          statusText = '可预约';
          customClass = 'canPre';
        }
        var date = dayjs.unix(item.day / 1000); //秒级
        // 获取当前年份
        var currentYear = dayjs().year();
        var formatStr = 'MM-DD';
        var lastIndex = 2;
        if (date.year() !== currentYear) {
          formatStr = 'YYYY-MM-DD';
          lastIndex = 3;
        }
        if (_this.dateCardList.length === 2) {
          lastIndex = 3;
        }
        var priceClass = '';
        if (item.promotionTag === 1) {
          priceClass = 'priceClass1';
        } else if (item.promotionTag === 2) {
          priceClass = 'priceClass2';
        } else {
          priceClass = '';
        }
        return {
          dateStatusTag: item.dateStatusTag,
          date: dayjs(item.day).format(formatStr),
          week: isToday ? ' 今天' : " \u5468".concat(dayStr[dayjs(item.day).day()]),
          isToday: isToday,
          showsList: showTimeList.length <= lastIndex ? showTimeList : showTimeList.slice(0, lastIndex).concat({
            showTime: '...',
            showId: '0'
          }),
          dateStr: dayjs(item.day).format('YYYY-MM-DD'),
          statusText: statusText,
          customClass: customClass,
          price: price,
          customId: customId,
          priceClass: priceClass,
          promotionTag: item.promotionTag,
          priceUrl: item.promotionTag === 2 ? 'https://p0.pipi.cn/rock/prod/common/image/985d55b33ac7e61fb987e25ab78a21af.png?imageMogr2/thumbnail/2500x2500%3E' : 'https://p0.pipi.cn/rock/prod/common/image/5ec34f94d13362b6654a03f12c3b0cc5.png?imageMogr2/thumbnail/2500x2500%3E'
        };
      });
      this.$nextTick(function () {
        var cardEle = document.getElementById('view-card');
        var cardListEle = document.getElementsByClassName('date-card-list')[0];
        if (cardEle && cardListEle) {
          var left = cardEle.getBoundingClientRect().left;
          cardListEle.scrollBy(left - 15, 0);
        }
      });
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    loadFontFace: function loadFontFace() {
      var _this2 = this;
      if (navigator.userAgent.includes('Android')) {
        var font = new FontFace('HelveticaNeue-Medium', 'url("https://obj.pipi.cn/festatic/common/media/1664353112901-MaoYanHeiTi-H1.otf")');
        font.load().then(function () {
          document.fonts.add(font);
          _this2.loaded = true;
        }).catch(function (error) {
          console.error('字体加载失败', error);
        });
      }
    },
    handleClickDate: function handleClickDate(date, status) {
      if ([SHOW_STATUS.CANCEL, SHOW_STATUS.DELAY, SHOW_STATUS.SOLD_OUT].includes(status)) {
        return;
      }
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_tztra8n3_mc',
        cid: 'c_c21utqjf',
        needTag: true,
        custom: {
          performance_id: this.performanceId
        }
      });
      Drip.redirect("/myshow/#/ticket-level?id=".concat(this.performanceId, "&modelStyle=").concat(this.modelStyle, "&cardSelectedDate=").concat(date, "&fromDateCard=1&isNewPage=true&isHotProject=").concat(Number(this.isDegradeCalPrice)));
    },
    handleClickAllDate: function handleClickAllDate() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_rk4d19v6_mc',
        cid: 'c_c21utqjf',
        custom: {
          performance_id: this.performanceId
        }
      });
      Drip.redirect("/myshow/#/ticket-level?id=".concat(this.performanceId, "&modelStyle=").concat(this.modelStyle, "&isNewPage=true&isHotProject=").concat(Number(this.isDegradeCalPrice)));
    }
  }
};